<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_table_of_contents_1"><span>À votre service</span></h1>
<p class="P_Normal__And__Left_Indent">Par Ariel Tachna</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Lorsqu’Anthony Mercer est entré dans le restaurant Au cœur du terroir, il était à la recherche d’un bon repas et d’une soirée agréable passée avec une amie. Il ne s’attendait pas à rencontrer – et encore moins coucher avec – Paul Delescluse, un serveur du restaurant. Après avoir passé une semaine magique ensemble à Paris, Anthony doit retourner à sa vie en Caroline du Nord, tandis que Paul reste en France.</p>
<p class="P_Normal">Malgré la distance et l’absence de promesses entre eux – Paul veut du sexe, pas une relation – Paul et Anthony forgent une amitié solide. Puis le travail d’Anthony le ramène à Paris, cette fois pour y rester. Paul est très heureux qu’il soit de retour, mais Anthony a un choix difficile à faire : être une autre des conquêtes de Paul, ou lutter pour obtenir la relation qu’ils pourraient avoir, si seulement Paul voulait bien y croire.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0001.vue?4b05a3df